import moment from 'moment'

export const getMaxDate = ({ maxDateType, maxDateValue }) => {
    try {
        const date = {
            max: '',
            maxYear: moment().add(1, 'years').format('YYYY')
        }
        switch(maxDateType) {
            case 18:
                date.max = moment().subtract('18', 'years')._d
                date.maxYear = moment().subtract('18', 'years').format('yyyy')
                break
            case '-year':
                date.max = moment().subtract('1', 'years')._d
                date.maxYear = moment().subtract('1', 'years').format('YYYY')
                break
            case 'today':
                date.max = moment()._d
                // minYear = moment().format('yyyy')
                date.maxYear = moment().format('yyyy')
                break
            case '2years':
                date.max = moment().add('2', 'years')._d
                date.maxYear = moment().add('2', 'years').format('YYYY')
                break
            case 'year':
                date.max = moment().add('1', 'years')._d
                date.maxYear = moment().add('1', 'years').format('YYYY')
                break
            case '6monthes':
                date.max = moment().add('6', 'months')._d
                date.maxYear = moment().add('6', 'months').format('YYYY')
                break
            case 'daysCount':
                if (maxDateValue) {
                    date.max = moment().add(maxDateValue, 'days')._d
                    date.maxYear = moment().add(maxDateValue, 'days').format('YYYY')
                }
                break
        }

        return date
    } catch (e) {
        console.error('datePickerHelper => getMaxDate', e)
    }
}

export const getMinDate = ({ minDateType, minYearEnter }) => {
    try {
        const date = {
            min: '', 
            minYear: minYearEnter ? minYearEnter : 1920,
        }

        switch(minDateType) {
            case 'today':
                date.min = moment()._d
                date.minYear = moment().format('yyyy')
                break
            case 'tomorrow':
                date.min = moment().add('1', 'days')._d
                date.minYear = moment().format('yyyy')
                break
            case '2days':
                date.min = moment().add('2', 'days')._d
                date.minYear = moment().format('yyyy')
                break
        }

        return date
    } catch (e) {
        console.error('datePickerHelper => getMinDate', e)
    }
}